module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"w100 section\">\n    <table name=\"list-items\" class=\"gridview__table\"></table>\n    <div style=\"width: 30px; text-align: center\"><div on-click=\"onItemAdd\"  name=\"add-button\" class=\"icon-add_box icon-24\"></div></div>\n</div>\n")
  }
  return __output.join("");

}